import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useRef, useEffect } from 'react';
import { shape, string } from 'prop-types';
import withLayoutProps from '../../../hocs/withLayoutProps';
import { usePromoterBusinessCard } from '@magalu/mixer-graphql';
import PromoterHeaderByType from './components/PromoterHeaderByType';
import { PromoterHeaderContainer } from './PromoterHeader.style';
var PromoterHeader = function PromoterHeader(_ref) {
  var staticProps = _ref["static"],
    structure = _ref.structure;
  var headerType = staticProps.headerType,
    store = staticProps.store,
    sticky = staticProps.sticky;
  var props = {
    staticProps: staticProps,
    structure: structure
  };
  var node = useRef(null);
  var promoterBusinessCardData = {};
  useEffect(function () {
    var _node$current;
    var parent = (_node$current = node.current) == null ? void 0 : _node$current.parentNode.style;
    if (sticky && parent) {
      parent.position = 'sticky';
      parent.top = 0;
      parent['z-index'] = 100;
    }
  }, []);
  if (headerType !== 'minimal') {
    promoterBusinessCardData = usePromoterBusinessCard({
      storeId: store == null ? void 0 : store.id
    }).promoterBusinessCardData;
  }
  return React.createElement(PromoterHeaderContainer, {
    ref: node
  }, React.createElement(PromoterHeaderByType, _extends({
    headerType: headerType,
    promoterData: promoterBusinessCardData
  }, props)));
};
process.env.NODE_ENV !== "production" ? PromoterHeader.propTypes = {
  "static": shape({
    headerType: string.isRequired,
    storeId: string
  }).isRequired,
  structure: shape({}).isRequired
} : void 0;
PromoterHeader.ssr = true;
PromoterHeader.displayName = 'PromoterHeader';
export default withLayoutProps(PromoterHeader);